<template>
  <div>
    <div v-if="associatedBusinessData.length" class="mx-1 mt-2">
      <div
        v-for="(item, index) in associatedBusinessData"
        :key="index"
        :class="$style.associateContainer"
        class="p-1 py-1 px-3 border baseContentFont border"
      >
        <div class="row">
          <div class="col" :class="$style.status">
            <strong>Company Name: </strong>{{ formatDisplay(item.companyName) }}
          </div>
          <div class="col" :class="$style.status">
            <strong>Phone Number: </strong
            ><span v-if="item.phoneNumber !== '' && item.phoneNumber !== null"
              >{{ formatDisplay(item.phoneNumber) }}
              {{ item.verified === 'Y' ? '(Verified)' : '(Not Verified)' }}
            </span>
          </div>
          <div class="col" :class="$style.status">
            <strong>FEIN: </strong>{{ formatDisplay(item.fein) }}
          </div>
        </div>
        <div class="row">
          <div class="col" :class="$style.status">
            <strong>Address: </strong>{{ formatDisplay(item.address) }}
          </div>
          <div class="col" :class="$style.status">
            <strong>Date First Seen: </strong
            >{{ formatDisplay(item.dateFirstSeen) }}
          </div>
          <div class="col" :class="$style.status">
            <strong>Date Last Seen: </strong
            >{{ formatDisplay(item.dateLastSeen) }}
          </div>
        </div>
        <div class="row">
          <div class="col" :class="$style.status">
            <strong>Executives: </strong>{{ formatDisplay(item.executives) }}
          </div>
        </div>
      </div>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    associatedBusiness: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    associatedBusinessData() {
      return this.associatedBusiness
    },
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.status {
  font-size: $size-content-font;
  color: $color-text-gray;
}

.associateContainer:nth-child(odd) {
  background: #fff;
}

.associateContainer:nth-child(even) {
  background: #eee;
}
</style>
